export const REPORT_MIN_MATCHES = 10;

// Kill switch: the Buyer Match Report is merged but not launched. While this is
// false every surface falls back to its pre-launch "coming soon" state.
const REPORT_ENABLED = false;

export const isReportEnabled = () => REPORT_ENABLED;

export const meetsMatchThreshold = (matchCount) => {
  const n = Number(matchCount);
  return Number.isFinite(n) && n >= REPORT_MIN_MATCHES;
};

export const isReportUnlocked = (matchCount) =>
  REPORT_ENABLED && meetsMatchThreshold(matchCount);

export const matchesUntilUnlock = (matchCount) => {
  const n = Number(matchCount);
  const safe = Number.isFinite(n) ? n : 0;
  return Math.max(REPORT_MIN_MATCHES - safe, 0);
};
